/* „Twój plan", from `profile-web-mockups-v2/_blocks.css`'s `.plate` at `f-zakladki.html`'s `.tall`
 * cut: the horizontal plate stood upright, its image full width at the top and the text under it.
 *
 * ── A dark slab in BOTH themes ──────────────────────────────────────────────────────────────
 * `--photo`, the graded plate the auth pane and the plan library's hero already stand on — it is
 * dark in both themes, which is the one property this surface needs from it.
 * Which is what makes its ink theme-independent too — `--plate-text*` in `tokens/colors.css`,
 * measured there. `var(--text)` on this surface would be near-black on Flame and the plan's own
 * name would vanish. The plan library's hero plate takes the same decision for the same reason.
 *
 * ── The lip is machined, and the drop is neutral ────────────────────────────────────────────
 * `--shadow-plate` is the mockup's `inset 0 1px 0 rgba(255,255,255,.08)` plus a black drop. Nothing
 * tinted, and nothing glowing: the one coloured shadow in this app is the ember primary's.
 *
 * ── The square at the top is part of the PLATE ──────────────────────────────────────────────
 * It is drawn whether or not there is a plaque in it — see the component. A plate that gained a
 * square when the read landed would move in its own centred column, and this screen does not move.
 *
 * Every colour, space, radius and type value is a token; heights and widths are layout. */

.plate {
  position: relative;
  overflow: hidden;
  color: var(--plate-text);
  background: var(--photo);
  border: var(--border-hairline) solid var(--plate-edge);
  border-radius: var(--radius-account-plate);
  box-shadow: var(--shadow-plate);
}

/* The square. `aspect-ratio` rather than a height, so it follows the column's width and the plate
 * keeps the mockup's proportion at every viewport it survives. */
.imageBox {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
}

.image {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 0;
}

/* The mockup's `.plate.tall .tx`: 20 above, 22 on the sides and below. It was written as
 * `--space-5-5px`, which is 5.5 PIXELS rather than the scale's 5.5th step — so the block stood hard
 * against the plate's left edge, which is the „cramped" the owner reported. */
.text {
  padding: var(--space-20px) var(--space-22px) var(--space-22px);
}

.eyebrow {
  font-size: var(--fs-account-plate-eyebrow);
  font-weight: var(--fw-bold);
  letter-spacing: var(--ls-head);
  color: var(--plate-text-2);
}

.name {
  margin: var(--space-1) var(--space-0);
  font-size: var(--fs-account-plate-name);
  font-weight: var(--fw-extrabold);
  line-height: var(--lh-plan);
  letter-spacing: var(--ls-display);
  color: var(--plate-text);
}

/* The mockup's `.plate p` leading, 1.45 — `body`'s own `--lh-relaxed` (1.5) is prose and grew the
 * line by a pixel, which the plate's centred column then paid for twice. */
.seats {
  font-size: var(--fs-body);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-note);
  color: var(--plate-text-2);
  font-variant-numeric: tabular-nums;
}

/* The two waits, drawn INSIDE the paragraphs whose line boxes are the reserve — see the component.
 * `inline-block` so each sits on its line rather than replacing it, and neither carries a margin:
 * the paragraph already owns the spacing above and below. */
.nameBar {
  display: inline-block;
  width: 62%;
  height: var(--fs-account-plate-name);
  vertical-align: middle;
}

.seatsBar {
  display: inline-block;
  width: 48%;
  height: var(--fs-body);
  vertical-align: middle;
}
